export default "/static/build/cs-glow.png";